export const formConstants = {
  CONTACTS_GETALL_REQUEST: 'CONTACTS_GETALL_REQUEST',
  CONTACTS_GETALL_SUCCESS: 'CONTACTS_GETALL_SUCCESS',
  CONTACTS_GETALL_FAILURE: 'CONTACTS_GETALL_FAILURE',
  CONTACTS_GET_REQUEST: 'CONTACTS_GET_REQUEST',
  CONTACTS_GET_SUCCESS: 'CONTACTS_GET_SUCCESS',
  CONTACTS_GET_FAILURE: 'CONTACTS_GET_FAILURE',

  BRANCH_REQUESTS_GETALL_REQUEST: 'BRANCH_REQUESTS_GETALL_REQUEST',
  BRANCH_REQUESTS_GETALL_SUCCESS: 'BRANCH_REQUESTS_GETALL_SUCCESS',
  BRANCH_REQUESTS_GETALL_FAILURE: 'BRANCH_REQUESTS_GETALL_FAILURE',
  BRANCH_REQUESTS_GET_REQUEST: 'BRANCH_REQUESTS_GET_REQUEST',
  BRANCH_REQUESTS_GET_SUCCESS: 'BRANCH_REQUESTS_GET_SUCCESS',
  BRANCH_REQUESTS_GET_FAILURE: 'BRANCH_REQUESTS_GET_FAILURE',

  JOBS_GETALL_REQUEST: 'JOBS_GETALL_REQUEST',
  JOBS_GETALL_SUCCESS: 'JOBS_GETALL_SUCCESS',
  JOBS_GETALL_FAILURE: 'JOBS_GETALL_FAILURE',
  JOBS_GET_REQUEST: 'JOBS_GET_REQUEST',
  JOBS_GET_SUCCESS: 'JOBS_GET_SUCCESS',
  JOBS_GET_FAILURE: 'JOBS_GET_FAILURE',
}